import React from "react"
import dataLayerHelper from "../../helpers/datalayer.helper"

import {
  FooterCTAContainer,
  FooterCTAButton,
  FooterCTAText,
} from "./footer-cta.styles"

const FooterCta = ({
  buttonText,
  linkUrl,
  dataLayer,
  content = "<p>Not sure <span>where to start</span> or <span>what to do next?</span></p>",
  marginTop = true,
}) => {
  return (
    <FooterCTAContainer
      className="full-bleed"
      to={linkUrl ? linkUrl : "/tech-career-path-quiz"}
      onClick={() => dataLayer && dataLayerHelper(dataLayer)}
      marginTop={marginTop}
    >
      <FooterCTAText
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
      <FooterCTAButton>
        {buttonText ? buttonText : "FIND YOUR CAREER PATH"}
      </FooterCTAButton>
    </FooterCTAContainer>
  )
}

export default FooterCta
